import React, { useState, useEffect } from "react";
import { Row, Col, Form, Card, CardBody, Modal, ModalBody } from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import history from "../../history";

import get from "lodash/get";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchingCountriesJson,
  fetchingRegionJson,
} from "../../redux/Global/actions";
import {
  fetchMotorCylce,
  fetchUserCountryMobileCode,
} from "../../redux/user/actions";
import {
  putPartnerForm,
  clearingPreviousReducer,
  fetchPartnersDetails,
} from "../../redux/partners/actions";
import {
  uploadGalleryUrl,
  uploadUrl,
  uploadVideoUrl,
} from "../../redux/uploadImage/action";
import PartnerPersonalForm from "../PartnerPersonalForm";
import PartnerPreviewPage from "../PartnerPreviewPage";

const _ = { get };

export default function PartnerDetails(props) {
  const dispatch = useDispatch();
  const [toggleAddModal, setToggleAddModal] = useState(false);
  const { countries, regionJson, tourCountriesJson } = useSelector(
    (state) => state.Global
  );
  const { usertype, userProfile } = useSelector((state) => state.Auth);
  const { countryMobileCode, motorCycle } = useSelector((state) => state.User);
  const { partnerDetailsData } = useSelector((state) => state.Partner);
  const [togglePreviewModal, setTogglePreviewModal] = useState(false);
  const { partnerRankingNumber } = useSelector((state) => state.Partner);

  const handleGoBack = () => {
    props.handleToggleModel();
  };

  const handleUpdate = () => {
    history.push(`/partner/rentals-update?id=${props.selectedId}`, {
      route: props.component,
    });
  };

  const handleEdit = () => {
    setToggleAddModal(!toggleAddModal);
  };

  const handlePutPartner = (data) => {
    dispatch(putPartnerForm(data, handlePutCallBack));
  };

  const handlePutCallBack = () => {
    setToggleAddModal(!toggleAddModal);
    dispatch(fetchPartnersDetails(props.selectedId));
  };

  useEffect(() => {
    if (props.selectedId) {
      props.handleFetchPartnerDetails(props.selectedId);
    }
  }, [props.selectedId]);

  useEffect(() => {
    dispatch(fetchingRegionJson());
    dispatch(fetchUserCountryMobileCode());
    dispatch(fetchMotorCylce("uk"));
    dispatch(fetchingCountriesJson());
  }, []);

  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={
                  props.partnerDetailsData && props.partnerDetailsData.name
                }
                iconClass={"hideexcel"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        props.elements,
                        "euToursElement.partnerDetailsElements.headingElement",
                        "Partner Detail"
                      )}
                    </span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      props.elements,
                      "euToursElement.partnerDetailsElements.businessNameElement",
                      "Business Name"
                    )}
                    titleName={
                      props.partnerDetailsData && props.partnerDetailsData.name
                        ? props.partnerDetailsData.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      props.elements,
                      "euToursElement.partnerDetailsElements.emailElement",
                      "Email"
                    )}
                    titleName={
                      props.partnerDetailsData && props.partnerDetailsData.email
                        ? props.partnerDetailsData.email
                        : "N/A"
                    }
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      props.elements,
                      "euToursElement.partnerDetailsElements.phoneElement",
                      "Phone"
                    )}
                    titleName={
                      props.partnerDetailsData &&
                      props.partnerDetailsData.mobile
                        ? `${props.partnerDetailsData &&
                            props.partnerDetailsData.mobile &&
                            props.partnerDetailsData.mobile
                              .callingCode} ${props.partnerDetailsData &&
                            props.partnerDetailsData.mobile &&
                            props.partnerDetailsData.mobile.number}`
                        : "N/A"
                    }
                  />
                </Col>
                {/* <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="Club coordination's name"
                    titleName={
                      props.partnerDetailsData &&
                      props.partnerDetailsData.clubCoordiantion
                        ? props.partnerDetailsData.clubCoordiantion
                        : "N/A"
                    }
                  />
                </Col> */}
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      props.elements,
                      "euToursElement.partnerDetailsElements.countryElement",
                      "Country"
                    )}
                    titleName={
                      props.partnerDetailsData &&
                      props.partnerDetailsData.country
                        ? props.partnerDetailsData.country
                        : "N/A"
                    }
                  />
                </Col>
                {/* <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="State"
                    titleName={
                      props.partnerDetailsData && props.partnerDetailsData.state
                        ? props.partnerDetailsData.state
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name="City"
                    titleName={
                      props.partnerDetailsData && props.partnerDetailsData.city
                        ? props.partnerDetailsData.city
                        : "N/A"
                    }
                  />
                </Col> */}
              </Row>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5 mb-3">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    props.elements,
                    "euToursElement.partnerDetailsElements.backElement",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={(e) => handleGoBack(e)}
                />
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    props.elements,
                    "euToursElement.partnerDetailsElements.editElement",
                    "Update"
                  )}
                  customClass={"btn-outline-dark bg-none ml-3 btnthemeColor"}
                  customClick={(e) => handleEdit(e)}
                />
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        props.elements,
                        "euToursElement.partnerDetailsElements.moderateElement",
                        "Moderate"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={(e) => handleUpdate(e)}
                    />
                  )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        props.elements,
                        "euToursElement.partnerDetailsElements.deleteElement",
                        "Delete"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() => props.handleRejectModal()}
                    />
                  )}
              </div>
            </CardBody>
          </Card>
        </Form>
      </div>
      <Modal
        isOpen={toggleAddModal}
        toggle={() => setToggleAddModal(!toggleAddModal)}
        backdrop={true}
        centered={true}
        size="xl"
        className="modal_main"
      >
        <ModalBody>
          <PartnerPersonalForm
            handleToggleModel={() => setToggleAddModal(!toggleAddModal)}
            countryList={tourCountriesJson}
            partnerDetailsData={partnerDetailsData}
            usertype={usertype}
            editInfo={true}
            handlePutPartner={handlePutPartner}
            uploadUrl={(data, callback, category) =>
              dispatch(uploadUrl(data, callback, category))
            }
            clearingPreviousReducer={clearingPreviousReducer}
            uploadGalleryUrl={(data, callback, category) =>
              dispatch(uploadGalleryUrl(data, callback, category))
            }
            uploadVideoUrl={(data, callback, category) =>
              dispatch(uploadVideoUrl(data, callback, category))
            }
            partnerRankingNumber={partnerRankingNumber}
            regionJson={regionJson}
            countryMobileCode={countryMobileCode}
            motorCycle={motorCycle}
            formType={"update"}
          />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}
